import React, { useState, useRef, useEffect } from 'react';
import _ from 'lodash';
import ClickOut from 'react-click-out';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import {
  ILink,
  IProd,
  IState,
  LocationCategory,
  ProductCategory,
  Replacement,
} from '../../interface';
import { connect, useSelector } from 'react-redux';
import localesReplacement from '../../utils/localesReplacement';
import { Dispatch } from 'redux';
import actions from '../../redux/actions';
import { productClickLogs } from '../../services';
import { APPNAME, FASTSCAN, MAP_PROD_TO_LOCA } from '../../constants';
import { useSearchParams } from 'react-router-dom';
import { useAppName } from '../../hooks/use-app-names';
import publicImage from '../../utils/publicImage';
import { PageType } from '../../interface/emnu';
import { InnerImageZoom } from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';

const cx = classnames.bind(style);

interface IProps {
  withoutMoreLink: boolean;
  dataList: Partial<IProd>;
  setProductCategories: (value: string[]) => void;
  setLocationCategories: (value: string[]) => void;
  replacements: Replacement;
  moreLinkClick?: () => void;
  whereToBuyEnabled: boolean | null;
  whereToServiceEnabled: boolean | null;
  onPrintClick?: any;
  locationCategoriesList: LocationCategory[] | null;
  productCategoriesList: ProductCategory[] | null;
  products?: any;
  vehicleP?: any;
  componentName?: any;
  Recommendation?: string;
}

export const OilThumb = (props: IProps) => {
  const {
    withoutMoreLink,
    dataList,
    setProductCategories,
    setLocationCategories,
    replacements,
    moreLinkClick,
    whereToBuyEnabled,
    whereToServiceEnabled,
    onPrintClick,
    locationCategoriesList,
    productCategoriesList,
    products,
    vehicleP,
    Recommendation,
    componentName
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const vehicle = useSelector((state: any) => state.filter.vehicle);
  const [searchParams, setSearchParams] = useSearchParams();
  const [visible, setVisible] = useState<boolean>(false);
  const [position, setPosition] = useState<string>('');
  const [visibleMarketing, setVisibleMarketing] = useState<boolean>(false);
  const [positionMarketing, setPositionMarketing] = useState<string>('');
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const h =
      ref.current &&
      ref.current?.getBoundingClientRect().height +
      ref.current?.getBoundingClientRect().y;
    _.toNumber(h) > document.documentElement.clientHeight
      ? setPosition('bottom')
      : setPosition('top');

    _.toNumber(h) > document.documentElement.clientHeight
      ? setPositionMarketing('top')
      : setPositionMarketing('bottom');

  }, [visible, visibleMarketing]);
  const redirect = () => {
    moreLinkClick && moreLinkClick();
  };
  const window: any = globalThis;
  window.dataLayer = window.dataLayer || [];
  const whereToBuy = (productCategoryId: number, oilName?: any) => {
    if (dataList.id) {
      if (Recommendation === PageType.ProductPage) {
        window.dataLayer.push({
          'event': 'whereToBuyClick',
          'pageType': PageType.ProductPage,
          'buttonName': 'whereToBuy',
          'oilName': products?.name,
          'countryCode': localStorage.getItem('countryCode')
        });
      }
      else {
        window.dataLayer.push({
          'event': 'whereToBuyClick',
          'pageType': PageType.RecommendedOils,
          'recommendationType': Recommendation,
          'buttonName': 'whereToBuy',
          'oilName': oilName.name,
          'oilCategory': componentName,//products?.name + " " + products?.code,
          'vehicleModel': `${vehicleP?.make} ${vehicleP?.model}`,
          'countryCode': localStorage.getItem('countryCode')
        });
      }


      productClickLogs({
        productId: dataList.id,
        type: 'Where to Buy',
      }).then(() => {
        if (localStorage.getItem('countryCode') === 'VNM') {
          setLocationCategories(['6', '7', '18']);
          setProductCategories([productCategoryId.toString()]);
        }
        else {
          setProductCategories([productCategoryId.toString()]);
          setLocationCategories(['3']);
        }
        searchParams.set('page', 'wheretobuy');
        isFastScan && searchParams.set(APPNAME, FASTSCAN);
        setSearchParams(searchParams);
      });
    }
  };

  const whereToService = (productCategoryId: number, oilName?: any) => {
    if (dataList.id) {
      if (Recommendation === PageType.ProductPage) {
        window.dataLayer.push({
          'event': 'whereToServiceClick',
          'pageType': PageType.ProductPage,
          'buttonName': 'whereToService',
          'oilName': products?.name,
          'countryCode': localStorage.getItem('countryCode')
        });
      }
      else {
        window.dataLayer.push({
          'event': 'whereToServiceClick',
          'pageType': PageType.RecommendedOils,
          'recommendationType': Recommendation,
          'buttonName': 'whereToService',
          'oilName': oilName?.name,
          'oilCategory': componentName, //products?.name + " " + products?.code,
          'vehicleModel': `${vehicleP?.make} ${vehicleP?.model}`,
          'countryCode': localStorage.getItem('countryCode')
        });
      }

      productClickLogs({
        productId: dataList.id,
        type: 'Where to Service',
      }).then(() => {
        const productName =
          _.find(productCategoriesList, ['id', productCategoryId])?.name ?? '';
        const locationName = _.get(MAP_PROD_TO_LOCA, productName);
        setProductCategories([productCategoryId.toString()]);
        setLocationCategories(
          _.chain(locationCategoriesList)
            .filter(['name', locationName])
            .map((it) => it.id.toString())
            .value(),
        );
        searchParams.set('page', 'wheretobuy');
        isFastScan && searchParams.set(APPNAME, FASTSCAN);
        setSearchParams(searchParams);
      });
    }
  };
  const openLink = (linkData: ILink) => {
    if (dataList.id) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'buyOnlineClicks',
        'pageType': PageType.RecommendedOils,
        'recommendationType': Recommendation,
        'buttonName': 'buyOnline:' + linkData.displayText,
        'oilName': products?.name,
        'oilCategory': `${products?.name} ${products?.code}`,
        'vehicleModel': `${vehicleP?.make} ${vehicleP?.model}`,
        'countryCode': localStorage.getItem('countryCode'),
      });
      productClickLogs({
        productId: dataList.id,
        type: 'Link',
        linkId: linkData.id,
      }).then(() => {
        window.open(linkData.link, '_blank');
      });
    }
  };

  const navigateToTurkyWhereToBuy = () => {
    window.open('/tr_tr/turkey/home/nereden-alabilirim.html');
  };

  return (
    <>
      <div
        className={`${cx('thumbnail', { 'no-link': withoutMoreLink, })}`}
      >
        {
          // <img
          //   src={
          //     dataList.packartUrl ? dataList.packartUrl
          //       : (_.get(dataList, 'thumb', null) || publicImage("no-image.png"))
          //   }
          // />
          // className={cx("zomm-container")}
          <div>
            <InnerImageZoom
              src={
                dataList.packartUrl?.[0] ? dataList.packartUrl[0]
                  : (_.get(dataList, 'thumb', null) || publicImage("no-image.png"))
              }
              zoomSrc={
                dataList.packartUrl?.[0] ? dataList.packartUrl[0]
                  : (_.get(dataList, 'thumb', null) || publicImage("no-image.png"))
              }
              zoomType="hover"
              zoomPreload={true} />
          </div>
          // <div className={cx("zomm-container")}>

          //   <div>
          //   <InnerImageZoom
          //     src="https://www.castrol.com/content/dam/castrol/country-sites/en_gb/united-kingdom/home/oil-selector-images/castrol_edge_5w-30_ll.png"
          //     zoomSrc="https://www.castrol.com/content/dam/castrol/country-sites/en_gb/united-kingdom/home/oil-selector-images/castrol_edge_5w-30_ll.png"
          //     zoomType="hover"
          //     zoomPreload={true}
          //   />
          //   </div>
          // </div>
        }
      </div>

      {/*
      <div className={cx("zomm-container")}>
        <h1>React Inner Image Zoom - Zoom On Hover Demo</h1>

        <div>
        <InnerImageZoom
          src="https://www.castrol.com/content/dam/castrol/country-sites/en_gb/united-kingdom/home/oil-selector-images/castrol_edge_5w-30_ll.png"
          zoomSrc="https://www.castrol.com/content/dam/castrol/country-sites/en_gb/united-kingdom/home/oil-selector-images/castrol_edge_5w-30_ll.png"
          zoomType="hover"
          zoomPreload={true}
        />
        </div>
      </div> */}

      {!!vehicle && onPrintClick && (
        <div className={`${cx('print-buttons')} ${cx('buttons')}`}>
          <a className={`primary-link ${cx('print')}`} onClick={onPrintClick}>
            {localesReplacement(replacements, 'Print')}
          </a>
        </div>
      )}
      {!withoutMoreLink && (
        <div className={cx('more-link')}>
          <span role='link' className='primary-link' onClick={redirect}>
            {localesReplacement(replacements, 'More information')}
          </span>
        </div>
      )}
      {dataList.links && !isFastScan && (
        <div className={cx('buttons')}>
          {!!whereToBuyEnabled && (
            <button
              className={`primary-button ${cx('where-to-buy')}`}
              onClick={() => {
                const countryCode = localStorage.getItem('countryCode');
                if (countryCode && countryCode === 'TUR') {
                  navigateToTurkyWhereToBuy();
                } else {
                  whereToBuy(dataList.productCategoryId as number, dataList);
                }
              }}
              key='wtb'
            >
              {localesReplacement(replacements, 'Where to buy')}
            </button>
          )}
          {!!whereToServiceEnabled && (
            <button
              className={`primary-button ${cx('where-to-service')}`}
              onClick={() =>
                whereToService(dataList.productCategoryId as number, dataList)
              }
              key='wts'
            >
              {localesReplacement(replacements, 'Where to service')}
            </button>
          )}

          {!!dataList.links.filter(x => x.isMarketing === false).length && !isFastScan && (
            <>
              {dataList.links.length > 1 ? (
                <ClickOut
                  className={cx('trigger')}
                  onClickOut={() => {
                    setVisible(false);
                  }}
                >
                  <>
                    <button
                      className={`primary-button ${cx('shop-online')}`}
                      onClick={() => setVisible(!visible)}
                    >
                      {localesReplacement(replacements, 'Shop online')}
                    </button>

                    <div
                      className={cx('flyout', { visible: visible }, position)}
                      ref={ref}
                    >
                      <ul>
                        {_.sortBy(dataList.links, o => o.displayText).map(item => (
                          !item.isMarketing && (
                            <li key={item.id}>
                              <a
                                onClick={() => openLink(item)}
                                rel='noreferrer'
                                target='_blank'
                                className={`link ${cx('shop online')}`}
                              >
                                {localesReplacement(
                                  replacements,
                                  item.displayText,
                                )}
                              </a>
                            </li>)
                        ))}
                      </ul>
                    </div>
                  </>
                </ClickOut>
              ) : (
                <button
                  className={`primary-button ${cx('shop-online', 'no-icon')}`}
                  onClick={() => openLink(_.head(dataList.links) as ILink)}
                >
                  {localesReplacement(replacements, 'Shop online')}
                </button>
              )}
            </>
          )}

          {dataList.links.filter(x => x.isMarketing === true).length > 0 && !isFastScan && (
            <>
              {dataList.links.length > 1 ? (
                <ClickOut
                  className={cx('trigger')}
                  onClickOut={() => {
                    setVisibleMarketing(false);
                  }}
                >
                  <>
                    <button
                      className={`primary-button ${cx('marketing-online')}`}
                      onClick={() => setVisibleMarketing(!visibleMarketing)}
                    >
                      {localesReplacement(replacements, 'Discover More')}
                    </button>

                    <div className={cx('marketing-flyout', { visible: visibleMarketing }, positionMarketing)}>

                      <ul>
                        {_.sortBy(dataList.links, o => o.displayText).map(item => (
                          item.isMarketing && (
                            <li key={item.id}>
                              <a
                                onClick={() => openLink(item)}
                                rel='noreferrer'
                                target='_blank'
                                className={`link ${cx('shop online')}`}
                              >
                                {localesReplacement(
                                  replacements,
                                  item.displayText,
                                )}
                              </a>
                            </li>)
                        ))}
                      </ul>


                    </div>

                  </>
                </ClickOut>
              ) : (
                <button
                  className={`primary-button ${cx('marketing-online', 'no-icon')}`}
                  onClick={() => openLink(_.head(dataList.links) as ILink)}
                >
                  {localesReplacement(replacements, 'Discover More')}
                </button>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
  whereToBuyEnabled: state.whereToBuyEnabled,
  locationCategoriesList: state.locationCategoriesList,
  productCategoriesList: state.productCategoriesList,
  whereToServiceEnabled: state.whereToServiceEnabled,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setProductCategories: (productCatgories: string[]) =>
    dispatch(actions.setProductCategories(productCatgories)),
  setLocationCategories: (locationCategories: string[]) =>
    dispatch(actions.setLocationCategories(locationCategories)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OilThumb);
